import { createFileRoute, Navigate } from '@tanstack/react-router'
import { LegalDocumentPage } from '../components/legal/LegalPage'
import { isLegalSlug } from '../legal/documents'

// `/about/{slug}` — one legal document (spec 2026-09-09-02).
//
// An unknown slug redirects to the index rather than rendering a 404: these
// URLs are printed in e-mails, WhatsApp templates and Meta's app settings, and
// a reader who mistypes one, or follows a link to a document that has since
// been renamed, is better served by the list of what does exist.
export const Route = createFileRoute('/about/$slug')({
    component: LegalSlugRoute,
})

function LegalSlugRoute() {
    const { slug } = Route.useParams()

    if (!isLegalSlug(slug)) {
        return <Navigate to="/about" replace />
    }

    return <LegalDocumentPage slug={slug} />
}
